import { Dispatch } from "redux";
import { getRequest } from "./request";

export const getApiRequest = (url: string, data: any, dispatch: Dispatch, type: any = null, cookie_option: any = null, setIsLoading: any) => {
  setIsLoading?.(true);
  getRequest(url, data, dispatch, type, setIsLoading, cookie_option);
};
